// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import GridSvg from '@rsuite/icon-font/lib/layout/Grid';
var Grid = createSvgIcon({
  as: GridSvg,
  ariaLabel: 'grid',
  category: 'layout',
  displayName: 'Grid'
});
export default Grid;